class BaoTabs extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
      
      [data-bao-tabs-el='tabpanel'][aria-hidden='true'] {
        display: none;
      }
    `
  }

  static get requiredElements () {
    return ['tab', 'tabpanel']
  }

  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => {
      this.els.tabpanel.elements.forEach((panel, index) => {
        panel.setAttribute('aria-hidden', (index > 0).toString())
      })

      if (this.equalizeHeight) {
        this.equalizeTabPanelHeight()
      }
    }, 10)
  }

  setupListeners () {
    this.onKeydown = this.onKeydown.bind(this)
    this.onClick = this.onClick.bind(this)

    this.els.tab.elements.forEach(tab => {
      this.listeners.add(tab, 'keydown', this.onKeydown)
      this.listeners.add(tab, 'click', this.onClick)
    })
  }

  equalizeTabPanelHeight () {
    const maxHeight = Math.max(
      ...this.els.tabpanel.elements.map(panel => panel.offsetHeight),
    )

    this.els.tabpanel.elements.forEach(panel => {
      panel.style.minHeight = `${maxHeight}px`
    })
  }

  onKeydown (event) {
    let flag = true

    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(event.currentTarget)
        break
      case 'ArrowRight':
        this.setSelectedToNextTab(event.currentTarget)
        break
      case 'Home':
        this.setSelectedTab(this.firstTab)
        break
      case 'End':
        this.setSelectedTab(this.lastTab)
        break
      default:
        flag = false
        break
    }

    if (flag) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  onClick (event) {
    this.setSelectedTab(event.currentTarget)
  }

  /**
   * {HTMLButtonElement} currentTab
   * {boolean} setFocus
   */
  setSelectedTab (currentTab, setFocus = true) {
    this.els.tab.elements.forEach(tab => {
      const tabMatchesCurrent = currentTab === tab

      tab.setAttribute('aria-selected', tabMatchesCurrent.toString())

      const panel = this.els.tabpanel.elements.find(
        p => p.getAttribute('id') === tab.getAttribute('aria-controls'),
      )
      panel.setAttribute('aria-hidden', (!tabMatchesCurrent).toString())

      if (currentTab === tab) {
        tab.removeAttribute('tabindex')

        if (setFocus) {
          tab.focus()
        }
      } else {
        tab.tabIndex = -1
      }
    })

    window.BAO.dispatchEvent(window.BAO.EVENTS.ACCORDION.TAB_CHANGED, {
      currentTab,
      index: this.els.tab.elements.findIndex(tab => tab === currentTab),
    })
  }

  /**
   * {HTMLButtonElement} currentTab
   */
  setSelectedToPreviousTab (currentTab) {
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab)
    } else {
      const indexOfPreviousTab = this.els.tab.elements.indexOf(currentTab) - 1

      this.setSelectedTab(this.els.tab.elements[indexOfPreviousTab])
    }
  }

  /**
   * {HTMLButtonElement} currentTab
   */
  setSelectedToNextTab (currentTab) {
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab)
    } else {
      const indexOfNextTab = this.els.tab.elements.indexOf(currentTab) + 1

      this.setSelectedTab(this.els.tab.elements[indexOfNextTab])
    }
  }

  get firstTab () {
    return this.els.tab.elements[0]
  }

  get lastTab () {
    return this.els.tab.elements[this.els.tab.elements.length - 1]
  }

  get equalizeHeight () {
    return this.hasAttribute('data-equalize-height')
  }
}

if (!customElements.get('bao-tabs')) {
  customElements.define('bao-tabs', BaoTabs)
}
